<template>
  <!-- NOTE (TEMPLATE) to show researcher informations -->

  <div class="animated fadeIn" v-if="isLoaded">
    <span v-show="false">{{ reactivity }}</span>
    <!-- loading component -->
    <Loading />
    <b-modal
      id="delItem"
      ref="delItem"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>حذف {{ selected.title }}</h4>
      </template>
      <template v-slot:modal-footer>
        <div>
          <b-row>
            <b-col cols="1"></b-col>
            <b-col cols="10">
              <!-- NOTE (b-doDeleteColleague) to confirm the Colleague removal -->
              <b-button variant="danger" size="lg" @click="doDeleteItem()"
                >حذف کن</b-button
              >

              <!-- NOTE (b-doDeleteColleague) to cancel the Colleague removal -->
              <b-button
                variant="warning"
                size="lg"
                class="ml-2"
                @click="$refs['delItem'].hide()"
                >لغو</b-button
              >
            </b-col>
            <b-col cols="1"></b-col>
          </b-row>
        </div>
      </template>
      از حذف این مورد مطمئن هستید؟
      <br />
      <br />این کار غیر قابل برگشت خواهد بود!
    </b-modal>
    <b-card
      v-if="$router.currentRoute.path.indexOf('/admin/user') == 0"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h2>
        {{ profile.name + " " + profile.lastName }} ({{ profile.status }})
      </h2>

      <hr />
      <b-tabs pills>
        <b-tab title="اطلاعات عمومی" active>
          <div v-if="profile.isDistinguished" class="my-6">
            <div
              class="img-box pointer"
              @click="$refs.profileImage.$refs.input.click()"
            >
              <img
                height="150"
                width="150"
                class="img"
                :src="
                  profile.avatar
                    ? profile.avatar
                    : 'https://www.sibberhuuske.nl/wp-content/uploads/2016/10/default-avatar-300x300.png'
                "
              />
              <v-icon x-large class="img-icon white--text">mdi-camera</v-icon>
              <div class="img-loading" v-if="profileLoading">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="40"
                ></v-progress-circular>
                <span class="mt-4">در حال بارگذاری... </span>
              </div>
            </div>
            <!--<div
              class="uploadPercentage"
              v-if="
                myImageFile.uploadPercentage != 0 &&
                myImageFile.uploadPercentage != 100
              "
            >
              <span>{{ myImageFile.uploadPercentage }}%</span>
            </div>-->
            <v-file-input
              v-show="false"
              @change="uploadProfile(imageFile)"
              v-model="imageFile"
              ref="profileImage"
            ></v-file-input>
          </div>
          <b-form-group label="تلفن همراه">
            <b-form-input
              trim
              type="number"
              :no-wheel="true"
              v-model="profile.mobile"
              disabled
            ></b-form-input>
          </b-form-group>
          <b-form-group label="نام">
            <b-form-input
              trim
              type="text"
              v-model="profile.name"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="نام خانوادگی">
            <b-form-input
              trim
              type="text"
              v-model="profile.lastName"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="پست الکترونیکی">
            <b-form-input
              trim
              type="text"
              v-model="profile.email"
              :state="validateEmail(profile.email) ? null : false"
              aria-describedby="email"
            ></b-form-input>
            <b-form-invalid-feedback id="email"
              >پست الکترونیک صحیح نیست</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label="دورنگار">
            <b-form-input trim type="text" v-model="profile.fax"></b-form-input>
          </b-form-group>
          <b-form-group description label="استان:">
            <v-autocomplete
              v-model="profile.stateId"
              :items="iran"
              @change="profile.cityId = ''"
              item-value="id"
              item-text="name"
              dense
              outlined
              class="dropdown-style"
              hide-details
            ></v-autocomplete>
          </b-form-group>

          <b-form-group description label="شهر:">
            <v-autocomplete
              v-model="profile.cityId"
              :items="
                iran
                  .filter((x) => x.id == profile.stateId)
                  .map((y) => y.cities)[0]
              "
              item-value="id"
              item-text="name"
              dense
              outlined
              class="dropdown-style"
              hide-details
            ></v-autocomplete>
          </b-form-group>
          <b-form-group label="آدرس">
            <b-form-input
              trim
              type="text"
              v-model="profile.address"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="تلفن منزل">
            <b-form-input
              trim
              type="number"
              v-model="profile.homePhone"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="تلفن محل کار">
            <b-form-input
              trim
              type="number"
              v-model="profile.officePhone"
            ></b-form-input>
          </b-form-group>
          <b-row class="mb-2">
            <b-col>
              <span class="select-text">دانشگاه</span>
            </b-col>
            <b-col class="text-left">
              <b-form-checkbox
                id="checkbox-1"
                v-model="profile.universityId"
                name="checkbox-1"
                :value="notUniversity"
                unchecked-value=""
                @change="reactivity = !reactivity"
              >
                سایر دانشگاه ها
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-form-group>
            <v-autocomplete
              v-model="profile.universityId"
              :items="universityList"
              :disabled="profile.universityId == notUniversity"
              item-value="id"
              item-text="text"
              dense
              outlined
              class="dropdown-style mb-2"
              hide-details
            ></v-autocomplete>
            <b-form-input
              trim
              class="mt-3"
              v-model="profile.universityOther"
              v-show="profile.universityId == notUniversity"
              placeholder="نام دانشگاه"
              @input="reactivity = !reactivity"
            ></b-form-input>
          </b-form-group>
          <b-row class="mb-2">
            <b-col>
              <span class="select-text">دانشگاه محل اشتغال</span>
            </b-col>
            <b-col class="text-left">
              <b-form-checkbox
                id="checkbox-2"
                v-model="profile.universityJobId"
                name="checkbox-2"
                value="1"
                unchecked-value=""
                @change="reactivity = !reactivity"
              >
                سایر دانشگاه ها
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-form-group>
            <v-autocomplete
              v-model="profile.universityJobId"
              :items="universityList"
              :disabled="profile.universityJobId == notUniversity"
              item-value="id"
              item-text="text"
              dense
              outlined
              class="dropdown-style mb-2"
              hide-details
            ></v-autocomplete>
            <b-form-input
              trim
              class="mt-3"
              v-model="profile.universityJobOther"
              v-show="profile.universityJobId == notUniversity"
              placeholder="نام دانشگاه"
              @input="reactivity = !reactivity"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="کدملی">
            <b-form-input
              trim
              type="number"
              v-model="profile.natCode"
              :state="checkCodeMeli(profile.natCode) ? null : false"
              aria-describedby="natCode"
            ></b-form-input>
            <b-form-invalid-feedback id="natCode"
              >کد ملی درست نیست</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label="آخرین مدرک تحصیلی">
            <b-form-select
              v-model="profile.lastDegree"
              :options="eduGradeOptions"
            ></b-form-select>
          </b-form-group>
          <b-form-group label="آدرس صفحه شخصی">
            <b-form-input
              trim
              type="text"
              v-model="profile.website"
            ></b-form-input>
          </b-form-group>
          <b-form-group label>
            <h5 class="text-info">
              مدارج تحصیلی و تخصصی ( كارشناسی و بالاتر ):
            </h5>
            <br />
            <b-button variant="success" class="mb-1" @click="addOffer()"
              >+</b-button
            >
            <!-- NOTE (degreesTable) to add Educational and professional qualifications -->
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="profile.educationDetails"
              :fields="eduFields"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
              :busy="eduBusy"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell(customerIndex)="data">
                <b-form-input
                  trim
                  v-model="data.item.customerIndex"
                  type="text"
                ></b-form-input>
              </template>
              <template v-slot:cell(operation)="data">
                <!-- NOTE (b-delOffer) to remove a row from degrees table -->
                <b-button
                  variant="danger"
                  class="mr-2"
                  @click="delOffer(data.item, data.index)"
                  >x</b-button
                >
              </template>

              <template v-slot:cell(eduGrade)="data">
                <b-form-select
                  class="myselect2"
                  id="second"
                  v-model="data.item.eduGrade"
                  :options="eduGradeOptions"
                  :settings="{ width: '100%' }"
                ></b-form-select>
                <!-- </div> -->
              </template>

              <template v-slot:cell(eduField)="data">
                <b-form-input
                  trim
                  v-model="data.item.eduField"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-input>
              </template>
              <template v-slot:cell(uniName)="data">
                <b-form-input
                  trim
                  v-model="data.item.uniName"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-input>
              </template>
              <template v-slot:cell(country)="data">
                <!-- <b-form-input trim  v-model="data.item.country" type="text" rows="6" max-rows="6"></b-form-input> -->
                <Select2
                  v-model="data.item.country"
                  :options="countries.map((x) => x.fa)"
                  :settings="{ width: '100%' }"
                ></Select2>
              </template>

              <template v-slot:cell(year)="data">
                <div style="text-align: center; vertical-align: middle">
                  <span v-show="false">{{ eduReactivity }}</span>
                  <b-form-input
                    trim
                    v-model="data.item.year"
                    type="text"
                    rows="6"
                    max-rows="6"
                    @click="
                      showYearModal[data.index] = true;
                      selectedIndex = data.index;
                      eduReactivity = !eduReactivity;
                    "
                    class="pointer"
                  ></b-form-input>
                  <year-modal
                    v-if="showYearModal[data.index]"
                    :chosenYear="data.item.year"
                    @dialogYear="getItemYear"
                    @showModal="getShowModal"
                  ></year-modal>
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <span v-show="false">{{ eduReactivity }}</span>
          </b-form-group>
          <b-form-group label="وضعیت کاربر">
            <b-form-select
              v-model="profile.status"
              :options="states"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            label="توضیحات تغییر وضعیت"
            v-if="profile.status == 'نیازمند به تکمیل'"
          >
            <b-form-textarea
              trim
              v-model="profile.adminMessage"
              type="text"
              rows="6"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group class="mt-8">
            <div class="d-flex">
              <b-form-checkbox v-model="profile.isDistinguished">
              </b-form-checkbox>
              <span class="ms-2 font-weight-bold">
                این پژوهشگر جزو پژوهشگرهای
                <span
                  class="font-weight-bold h5 mx-1 light-blue--text text--darken-4"
                >
                  <v-icon class="amber--text darken-2--text">mdi-star</v-icon>
                  ممتاز</span
                >
                است.
              </span>
            </div>
          </b-form-group>

          <div class="my-8" v-if="profile.isDistinguished">
            <b-form-group label="موضوع فعالیت زیست فناوری">
              <v-autocomplete
                v-model="profile.catId"
                :items="categories"
                item-value="code"
                item-text="label"
                dense
                outlined
                class="dropdown-style mb-4"
                hide-details
              ></v-autocomplete>
            </b-form-group>

            <div class="pa-5 blue-grey lighten-5" style="border-radius: 15px">
              <label class="font-weight-bold blue-grey--text text--darken-3"
                >شرح فعالیت‌های انجام گرفته در زیست فناوری</label
              >
              <vue-ckeditor v-model="profile.doneActivities" :config="config" />
            </div>

            <div
              class="pa-5 blue-grey lighten-5 mt-6"
              style="border-radius: 15px"
            >
              <label class="font-weight-bold blue-grey--text text--darken-3"
                >شرح فعالیت‌های در دست انجام و برنامه ریزی شده</label
              >
              <vue-ckeditor
                v-model="profile.inProgressActivities"
                :config="config"
              />
            </div>

            <div
              class="pa-5 blue-grey lighten-5 mt-6"
              style="border-radius: 15px"
            >
              <label class="font-weight-bold blue-grey--text text--darken-3"
                >مقالات حوزه زیست فناوری</label
              >
              <br />
              <b-button
                variant="success"
                class="mb-1"
                @click="addItem('articles')"
                >+</b-button
              >
              <!-- NOTE (degreesTable) to add Educational and professional qualifications -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="articles"
                :fields="articlesFields"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(title)="data">
                  <b-form-input
                    trim
                    v-model="data.item.title"
                    type="text"
                  ></b-form-input>
                </template>
                <template v-slot:cell(DOI)="data">
                  <span v-show="false">
                    {{ reactivity }}
                  </span>
                  <b-input-group>
                    <template #append>
                      <div class="px-2">
                        <div class="pt-1" v-if="doiLoading[data.index]">
                          <v-progress-circular
                            indeterminate
                            color="primary"
                            :size="25"
                          ></v-progress-circular>
                        </div>
                        <div
                          class="pt-2"
                          v-else-if="
                            !doiLoading[data.index] &&
                            !wrongDoi[data.index] &&
                            haveChar[data.index]
                          "
                        >
                          <v-icon class="green--text">mdi-check-circle</v-icon>
                        </div>
                        <div
                          class="pt-2"
                          v-else-if="
                            !doiLoading[data.index] &&
                            wrongDoi[data.index] &&
                            haveChar[data.index]
                          "
                        >
                          <v-icon class="red--text">mdi-close-circle</v-icon>
                        </div>
                      </div>
                    </template>
                    <b-form-input
                      trim
                      v-model="data.item.DOI"
                      type="text"
                      :style="
                        !doiLoading[data.index] &&
                        wrongDoi[data.index] &&
                        haveChar[data.index]
                          ? 'border: 1px solid red'
                          : ''
                      "
                      @input="checkDoi(data.item.DOI, data.index)"
                    ></b-form-input>
                  </b-input-group>
                  <span
                    class="fs-xsmall red--text px-1"
                    dir="ltr"
                    v-if="
                      !doiLoading[data.index] &&
                      wrongDoi[data.index] &&
                      haveChar[data.index]
                        ? 'border: 1px solid red'
                        : ''
                    "
                    >{{ errorMessage[data.index] }}</span
                  >
                </template>
                <template v-slot:cell(operation)="data">
                  <!-- NOTE (b-delOffer) to remove a row from degrees table -->
                  <div class="text-center">
                    <b-button
                      variant="danger"
                      class="mx-auto"
                      @click="delItem('articles', data.item, data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(publishDate)="data">
                  <!-- <b-form-input trim  v-model="data.item.year" type="text"></b-form-input> -->
                  <date-picker
                    color="#7b1fa2"
                    v-model="data.item.publishDate"
                    :auto-submit="true"
                    :editable="true"
                    :show="false"
                  >
                    <!-- <div slot="label">سال</div> -->
                  </date-picker>
                </template>
              </b-table>
            </div>

            <div
              class="pa-5 blue-grey lighten-5 mt-6"
              style="border-radius: 15px"
            >
              <label class="font-weight-bold blue-grey--text text--darken-3"
                >اختراعات به ثبت رسیده</label
              >
              <br />
              <b-button
                variant="success"
                class="mb-1"
                @click="addItem('inventions')"
                >+</b-button
              >
              <!-- NOTE (degreesTable) to add Educational and professional qualifications -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="inventions"
                :fields="inventionsFields"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(title)="data">
                  <b-form-input
                    trim
                    v-model="data.item.title"
                    type="text"
                  ></b-form-input>
                </template>
                <template v-slot:cell(operation)="data">
                  <!-- NOTE (b-delOffer) to remove a row from degrees table -->
                  <div class="text-center">
                    <b-button
                      variant="danger"
                      class="mx-auto"
                      @click="delItem('inventions', data.item, data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(submitDate)="data">
                  <!-- <b-form-input trim  v-model="data.item.year" type="text"></b-form-input> -->
                  <date-picker
                    color="#7b1fa2"
                    v-model="data.item.submitDate"
                    :auto-submit="true"
                    :editable="true"
                    :show="false"
                  >
                    <!-- <div slot="label">سال</div> -->
                  </date-picker>
                </template>
              </b-table>
            </div>
            <br />

            <div
              class="pa-5 blue-grey lighten-5 mt-6"
              style="border-radius: 15px"
            >
              <label class="font-weight-bold blue-grey--text text--darken-3"
                >کتاب‌های به چاپ رسیده</label
              >
              <br />
              <b-button variant="success" class="mb-1" @click="addItem('books')"
                >+</b-button
              >
              <!-- NOTE (degreesTable) to add Educational and professional qualifications -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="books"
                :fields="booksFields"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(title)="data">
                  <b-form-input
                    trim
                    v-model="data.item.title"
                    type="text"
                  ></b-form-input>
                </template>
                <template v-slot:cell(publisher)="data">
                  <b-form-input
                    trim
                    v-model="data.item.publisher"
                    type="text"
                  ></b-form-input>
                </template>
                <template v-slot:cell(operation)="data">
                  <!-- NOTE (b-delOffer) to remove a row from degrees table -->
                  <div class="text-center">
                    <b-button
                      variant="danger"
                      class="mx-auto"
                      @click="delItem('books', data.item, data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(publishDate)="data">
                  <!-- <b-form-input trim  v-model="data.item.year" type="text"></b-form-input> -->
                  <date-picker
                    color="#7b1fa2"
                    v-model="data.item.publishDate"
                    :auto-submit="true"
                    :editable="true"
                    :show="false"
                  >
                    <!-- <div slot="label">سال</div> -->
                  </date-picker>
                </template>
              </b-table>
            </div>
            <br />

            <div
              class="pa-5 blue-grey lighten-5 mt-6"
              style="border-radius: 15px"
            >
              <label class="font-weight-bold blue-grey--text text--darken-3"
                >گرنت‌های دریافت شده
              </label>
              <br />
              <b-button
                variant="success"
                class="mb-1"
                @click="addItem('grants')"
                >+</b-button
              >
              <!-- NOTE (degreesTable) to add Educational and professional qualifications -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="grants"
                :fields="grantFields"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(title)="data">
                  <b-form-input
                    trim
                    v-model="data.item.title"
                    type="text"
                  ></b-form-input>
                </template>
                <template v-slot:cell(subject)="data">
                  <b-form-input
                    trim
                    v-model="data.item.subject"
                    type="text"
                  ></b-form-input>
                </template>
                <template v-slot:cell(operation)="data">
                  <!-- NOTE (b-delOffer) to remove a row from degrees table -->
                  <div class="text-center">
                    <b-button
                      variant="danger"
                      class="mx-auto"
                      @click="delItem('grants', data.item, data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(grantYear)="data">
                  <!-- <b-form-input trim  v-model="data.item.year" type="text"></b-form-input> -->
                  <span v-show="false">{{ eduReactivity }}</span>
                  <b-form-input
                    trim
                    v-model="data.item.grantYear"
                    type="text"
                    rows="6"
                    max-rows="6"
                    @click="
                      showGrantYearModal[data.index] = true;
                      selectedGrantIndex = data.index;
                      eduReactivity = !eduReactivity;
                    "
                    class="pointer"
                  ></b-form-input>
                  <year-modal
                    v-if="showGrantYearModal[data.index]"
                    :chosenYear="data.item.grantYear"
                    @dialogYear="getGrantYear"
                    @showModal="getShowGrantModal"
                  ></year-modal>
                </template>
              </b-table>
            </div>
          </div>
          <div class="d-flex">
            <!-- NOTE (b-editUser) to submit changes in user profile -->

            <v-btn
              class="green-btn mt-2"
              :disabled="hasWrongDoi || hasloading"
              @click="editUser()"
            >
              <v-icon class="me-2">mdi-check</v-icon>
              ثبت تغییرات
            </v-btn>
          </div>
        </b-tab>
        <b-tab title="فایل‌ها و مدارک">
          <h6>
            <b-input-group size="md">
              <b-form-input
                trim
                v-model="fileFilter"
                type="search"
                id="filterInput"
                placeholder="جستجو"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  :disabled="!fileFilter"
                  @click="fileFilter = ''"
                  variant="danger"
                  >حذف</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </h6>

          <!-- NOTE (t-files) to show the files and documents list -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fileFields"
            :items="profile.files"
            empty-text="فایلی وجود ندارد"
            striped
            :busy="fileBusy"
            :filter="fileFilter"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(url)="data">
              <div style="text-align: center; vertical-align: middle">
                <!-- NOTE (<a>) to download file -->
                <a class="btn btn-success" :href="data.value">دریافت فایل</a>
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </b-tab>
        <b-tab title="حمایت‌ها">
          <b-input-group size="md">
            <b-form-input
              trim
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="جستجو"
            ></b-form-input>
            <b-input-group-append>
              <!-- NOTE (b-delete) to delete the text of the search bar -->
              <b-button
                :disabled="!filter"
                @click="filter = ''"
                variant="danger"
                >حذف</b-button
              >
            </b-input-group-append>
          </b-input-group>

          <!-- NOTE (t-proposals) to show the user proposals list -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fields"
            :items="computedItems"
            :current-page="currentPage"
            :per-page="perPage"
            empty-text="هنوز طرحی ثبت نشده است"
            striped
            :busy="isBusy"
            :filter="filter"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    width: 150px;
                    margin: auto;
                  "
                >
                  <!-- NOTE (<a>) to show the proposal details -->
                  <a
                    v-if="data.item.requestType == 'طرح پژوهشی'"
                    :href="'/admin/proposal/' + data.item.id"
                    target="_blank"
                    class="btn btn-primary text-light"
                    style="width: 100%"
                    >جزییات</a
                  >
                  <a
                    v-if="data.item.requestType == 'رساله دکتری'"
                    :href="'/admin/phdProposal/' + data.item.id"
                    target="_blank"
                    class="btn btn-primary text-light"
                    style="width: 100%"
                    >جزییات</a
                  >
                  <a
                    v-if="data.item.requestType == 'پایان نامه کارشناسی ارشد'"
                    :href="'/admin/masterProposal/' + data.item.id"
                    target="_blank"
                    class="btn btn-primary text-light"
                    style="width: 100%"
                    >جزییات</a
                  >
                  <a
                    v-if="data.item.requestType == 'پسادکتری'"
                    :href="'/admin/postDoc/' + data.item.id"
                    target="_blank"
                    class="btn btn-primary text-light"
                    style="width: 100%"
                    >جزییات</a
                  >
                  <a
                    v-if="data.item.requestType == 'مقاله'"
                    :href="'/admin/article/' + data.item.id"
                    target="_blank"
                    class="btn btn-primary text-light"
                    style="width: 100%"
                    >جزییات</a
                  >

                  <a
                    v-if="data.item.requestType == 'فرصت مطالعاتی'"
                    :href="'/admin/opportunity/' + data.item.id"
                    target="_blank"
                    class="btn btn-primary text-light"
                    style="width: 100%"
                    >جزییات</a
                  >
                  <a
                    v-if="data.item.requestType == 'نشست تخصصی'"
                    :href="'/admin/meeting/' + data.item.id"
                    target="_blank"
                    class="btn btn-primary text-light"
                    style="width: 100%"
                    >جزییات</a
                  >
                  <a
                    v-if="data.item.requestType == 'نخبگان وظیفه'"
                    :href="'/admin/Elite/' + data.item.id"
                    target="_blank"
                    class="btn btn-primary text-light"
                    style="width: 100%"
                    >جزییات</a
                  >
                </div>
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (currentPage - 1) }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-text="ابتدا"
            prev-text="قبلی"
            next-text="بعدی"
            last-text="آخر"
            align="center"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-tab>
        <b-tab title="ویرایش رمز">
          <h3>ویرایش رمز پژوهشگر</h3>
          <b-form-group label="رمز جدید">
            <b-form-input
              v-model="password"
              type="password"
              autocomplete="new-password"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="تکرار رمز جدید">
            <b-form-input
              v-model="repeatPassord"
              type="password"
            ></b-form-input>
          </b-form-group>
          <v-btn
            style="box-shadow: none !important"
            :disabled="busy || !password || !repeatPassord"
            @click="resetPass()"
            class="primary white--text btn-radius font-weight-bold"
          >
            ویرایش رمز
          </v-btn>
        </b-tab>
      </b-tabs>
    </b-card>

    <router-view></router-view>
  </div>
</template>

<script>
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import utilities from "../../mixins/utilities"; // REVIEW
import md5 from "js-md5";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
import VueCkeditor from "vue-ckeditor2";
import YearModal from "./../../components/YearModal";
export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    datePicker: VuePersianDatetimePicker,
    VueCkeditor,
    YearModal,
  },
  mixins: [utilities], // REVIEW
  data() {
    return {
      reactivity: false,
      hasWrongDoi: false,
      hasloading: false,
      filter: "",
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      iran: [],
      profile: {},
      universityList: [],
      articles: [],
      inventions: [],
      books: [],
      grants: [],
      articlesFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان مقاله" },
        { key: "publishDate", label: "تاریخ چاپ" },
        { key: "DOI", label: "DOI" },
        { key: "operation", label: "حذف" },
      ],
      inventionsFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان" },
        { key: "submitDate", label: "تاریخ ثبت" },
        { key: "operation", label: "حذف" },
      ],
      booksFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان" },
        { key: "publisher", label: "انتشارات" },
        { key: "publishDate", label: "تاریخ چاپ" },
        { key: "operation", label: "حذف" },
      ],
      grantFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان گرنت" },
        { key: "subject", label: "موضوع فعالیت" },
        { key: "grantYear", label: "سال انجام پژوهش" },
        { key: "operation", label: "حذف" },
      ],
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "Font",
          ],
        ],
      },
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      states: [
        { value: "در حال بررسی", eng: "ongoing", text: "در حال بررسی" },
        { value: "تایید", eng: "approve", text: "تایید" },
        { value: "معلق", eng: "suspend", text: "معلق" },
        {
          value: "نیازمند به تکمیل",
          eng: "incomplete",
          text: "نیازمند به تکمیل",
        },
      ],
      fileBusy: true,
      fileFilter: "",
      fields: [
        { key: "index", label: "ردیف" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "requestsCode", label: "کد" },
        { key: "requestType", label: "نوع حمایت" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "status", label: "وضعیت" },
        { key: "lastUpdat", label: "آخرین بروزرسانی" },
        { key: "operation", label: "عملیات" },
      ],
      // items: [{ faSubject: 'test1' , project_status: 'نیاز به تکمیل'}, { faSubject: 'test2', project_status: 'ثبت شده' }],
      items: [],
      eduFields: [
        { key: "index", label: "#" },
        { key: "eduGrade", label: "درجه تحصیلی" },
        { key: "eduField", label: "رشته تحصیلی" },
        { key: "uniName", label: "نام موسسه محل تحصیل" },
        { key: "country", label: "كشور محل تحصیل" },
        { key: "year", label: "سال دریافت" },
        { key: "operation", label: "حذف" },
      ],
      eduGradeOptions: ["کارشناسی", "کارشناسی ارشد", "دکتری", "دکتری حرفه ای"],
      isBusy: false,
      password: "",
      repeatPassord: "",
      busy: false,
      isLoaded: true,
      selected: {},
      selectedOffer: {},
      selectedFile: "",
      wrongDoi: [],
      interval: "",
      doiLoading: [],
      haveChar: [],
      countries: [],
      errorMessage: [],
      eduBusy: false,
      eduReactivity: false,
      imageFile: [],
      myImageFile: new Object({
        uploadPercentage: 0,
      }),
      profileLoading: false,
      categories: [],
      showYearModal: [],
      selectedIndex: "",
      showGrantYearModal: [],
      selectedGrantIndex: "",
    };
  },

  methods: {
    getItemYear(value) {
      this.profile.educationDetails[this.selectedIndex].year = value;
    },
    getShowModal(value) {
      this.showYearModal[this.selectedIndex] = value;
      this.eduReactivity = !this.eduReactivity;
    },
    getGrantYear(value) {
      this.grants[this.selectedGrantIndex].grantYear = value;
    },
    getShowGrantModal(value) {
      this.showGrantYearModal[this.selectedGrantIndex] = value;
      this.eduReactivity = !this.eduReactivity;
    },
    checkDoi(doi, index) {
      this.wrongDoi[index] = false;
      this.haveChar[index] = false;

      // button disable condition
      if (this.wrongDoi.includes(true)) {
        this.hasWrongDoi = true;
      } else {
        this.hasWrongDoi = false;
      }
      clearInterval(this.interval);

      this.interval = setInterval(() => {
        if (doi.length > 0) {
          this.haveChar[index] = true;
          this.getArticleInfo(doi, index);
          clearInterval(this.interval);
        }
      }, 1500);
    },
    getArticleInfo(doi, index) {
      this.doiLoading[index] = true;
      // button disable condition
      if (this.doiLoading.includes(true)) {
        this.hasloading = true;
      } else {
        this.hasloading = false;
      }
      this.reactivity = !this.reactivity;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/article/doi",
          { doi: doi },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.wrongDoi[index] = false;
          this.errorMessage[index] = "";
          clearInterval(this.interval);
          setTimeout(() => {
            this.doiLoading[index] = false;
            // button disable condition
            if (this.doiLoading.includes(true)) {
              this.hasloading = true;
            } else {
              this.hasloading = false;
            }
            this.reactivity = !this.reactivity;
          }, 1000);

          // button disable condition
          if (this.wrongDoi.includes(true)) {
            this.hasWrongDoi = true;
          } else {
            this.hasWrongDoi = false;
          }
        })
        .catch((err) => {
          if (err.response.status == 404 || err.response.status == 409) {
            this.wrongDoi[index] = true;
            this.errorMessage[index] = err.response.data;
            clearInterval(this.interval);
          } else {
            console.log(err);
          }
          // button disable condition
          if (this.wrongDoi.includes(true)) {
            this.hasWrongDoi = true;
          } else {
            this.hasWrongDoi = false;
          }
          if (this.doiLoading.includes(true)) {
            this.hasloading = true;
          } else {
            this.hasloading = false;
          }

          setTimeout(() => {
            this.doiLoading[index] = false;
            this.reactivity = !this.reactivity;
          }, 1000);
        });
    },
    addOffer() {
      // NOTE (m-addOffer) to add Educational and professional qualifications
      this.profile.educationDetails.push({
        eduGrade: "",
        eduField: "",
        uniName: "",
        country: "",
        year: "",
        operation: "",
      });
      this.showYearModal.push(false);
    },
    delOffer(offer, index) {
      this.selectedOffer = index;
      this.selected = offer;
      this.profile.educationDetails.splice(this.selectedOffer, 1);
    },
    doDeleteItem() {
      this[this.variable].splice(this.selectedFile, 1);
      if (this.variable == "articles") {
        this.wrongDoi.splice(this.selectedFile, 1);
        this.haveChar.splice(this.selectedFile, 1);
        this.doiLoading.splice(this.selectedFile, 1);
        this.errorMessage.splice(this.selectedFile, 1);
        // button disable condition
        if (this.wrongDoi.includes(true)) {
          this.hasWrongDoi = true;
        } else {
          this.hasWrongDoi = false;
        }
        if (this.doiLoading.includes(true)) {
          this.hasloading = true;
        } else {
          this.hasloading = false;
        }
      }
      this.$bvModal.hide("delItem");
    },
    addItem(variable) {
      this[variable].push({});
      if (variable == "articles") {
        this.wrongDoi.push(false);
        this.haveChar.push(false);
        this.doiLoading.push(false);
        this.errorMessage.push("");
        // button disable condition
        if (this.wrongDoi.includes(true)) {
          this.hasWrongDoi = true;
        } else {
          this.hasWrongDoi = false;
        }
      }
    },
    delItem(variable, item, index) {
      this.variable = variable;
      this.selected = item;
      this.selectedFile = index;
      this.$refs["delItem"].show();
    },
    getCountries() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/countries",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.countries = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    resetPass() {
      if (this.password == this.repeatPassord) {
        this.busy = true;
        this.$http
          .post(
            this.baseUrl + "/setad/admin/researcher/resetPassword",
            {
              researcherId: this.$route.params.id,
              password: md5(this.password),
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.busy = false;
            if (res.status == 200) {
              this.toast(res.data, "success");
              this.password = "";
              this.repeatPassord = "";
            }
          })
          .catch((err) => {
            this.busy = false;
            console.log(err);
            this.toast(err.response.data, "error");
            if (err.response.status == 403) {
              if (err.response.data == "expired")
                this.$router.push({
                  path: "/login",
                  query: { return: window.location.pathname },
                });
              else
                this.$router.push({
                  path: "/login",
                  query: { return: window.location.pathname },
                });
            }
          });
      } else {
        this.toast("رمز جدید با تکرار آن مطابقت ندارد", "error");
      }
    },
    editUser() {
      if (this.validateEmail(this.profile.email) || this.profile.email == "") {
        if (
          this.checkCodeMeli(this.profile.natCode) ||
          this.profile.natCode == ""
        ) {
          this.$bvModal.show("loading");
          this.isLoaded = false;
          // NOTE (m-editUser) to submit profiles change
          this.$http
            .post(
              this.baseUrl + "/setad/admin/researcher/edit",
              {
                researcherId: this.$route.params.id,
                name: this.profile.name,
                lastName: this.profile.lastName,
                lastDegree: this.profile.lastDegree,
                email: this.profile.email,
                fax: this.profile.fax,
                stateId: this.profile.stateId ? this.profile.stateId : null,
                cityId: this.profile.cityId ? this.profile.cityId : null,
                address: this.profile.address,
                homePhone: this.profile.homePhone,
                officePhone: this.profile.officePhone,
                status: this.states.filter(
                  (x) => x.value == this.profile.status
                )[0].eng,
                adminMessage:
                  this.states == "نیازمند به تکمیل"
                    ? this.profile.adminMessage
                    : "",
                universityId: this.profile.universityId,
                universityOther:
                  this.profile.universityId == this.notUniversity
                    ? this.profile.universityOther
                    : "",
                universityJobId: this.profile.universityJobId,
                universityJobOther:
                  this.profile.universityJobId == this.notUniversity
                    ? this.profile.universityJobOther
                    : "",
                natCode: this.profile.natCode,
                website: this.profile.website,
                educationDetails: this.profile.educationDetails,
                isDistinguished: this.profile.isDistinguished,
                doneActivities: this.profile.isDistinguished
                  ? this.profile.doneActivities
                  : undefined,
                inProgressActivities: this.profile.isDistinguished
                  ? this.profile.inProgressActivities
                  : undefined,
                articles: this.profile.isDistinguished
                  ? this.articles
                  : undefined,
                inventions: this.profile.isDistinguished
                  ? this.inventions
                  : undefined,
                books: this.profile.isDistinguished ? this.books : undefined,
                grants: this.profile.isDistinguished ? this.grants : undefined,
                catId: this.profile.isDistinguished
                  ? this.profile.catId
                  : undefined,
              },
              {
                headers: {
                  Authorization: "Bearer: " + localStorage.getItem("userId"),
                },
              }
            )
            .then((res) => {
              this.$bvModal.hide("loading");
              this.isLoaded = true;
              if (res.status == 200) {
                this.toast(res.data, "success");
                this.update();
              }
            })
            .catch((err) => {
              this.$bvModal.hide("loading");
              this.isLoaded = true;
              console.log(err);
              this.toast(err.response.data, "error");
              if (err.response.status == 403) {
                if (err.response.data == "expired")
                  this.$router.push({
                    path: "/login",
                    query: { return: window.location.pathname },
                  });
                // else this.$router.replace("/unauthorize");
                else
                  this.$router.push({
                    path: "/login",
                    query: { return: window.location.pathname },
                  });
              }
            });
        } else {
          this.toast("کدملی وارد شده صحیح نمی باشد", "error");
        }
      } else {
        if (
          this.checkCodeMeli(this.profile.natCode) ||
          this.profile.natCode == ""
        ) {
          this.toast("پست الکترونیکی وارد شده صحیح نمی باشد", "error");
        } else {
          this.toast("کدملی و پست الکترونیکی وارد شده صحیح نمی باشند", "error");
        }
      }
    },
    onMounted() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.isBusy = true;
      this.fileBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universityList = res.data;
          this.universityList.push(
            new Object({
              id: 1,
              text: "سایر دانشگاه ها",
            })
          );
          this.universityList.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
          this.isBusy = false;
          this.fileBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });
      this.$http
        .post(
          this.baseUrl + "/setad/admin/researcher/getInfo",
          {
            researcherId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.profile = res.data.researcher;
          this.items = res.data.requests;
          this.articles = this.profile.articles;
          this.books = this.profile.books;
          this.inventions = this.profile.inventions;
          this.grants = this.profile.grants;
          this.totalRows = this.items.length;
          for (
            let index = 0;
            index < this.profile.educationDetails.length;
            index++
          ) {
            this.showYearModal.push(false);
          }
          this.getStatesAndCities();
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          this.isBusy = false;
          this.fileBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
          this.$bvModal.hide("loading");
          this.isLoaded = true;
        });
    },
    update() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.isBusy = true;
      this.fileBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/researcher/getInfo",
          {
            researcherId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.profile = res.data.researcher;
          this.items = res.data.requests;
          this.articles = this.profile.articles;
          this.books = this.profile.books;
          this.inventions = this.profile.inventions;
          this.grants = this.profile.grants;
          this.totalRows = this.items.length;
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          this.isBusy = false;
          this.fileBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
          this.$bvModal.hide("loading");
          this.isLoaded = true;
        });
    },
    getStatesAndCities() {
      this.$http
        .get(this.baseUrl + "/setad/options/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    uploadProfile(file) {
      if (!file) {
        return;
      }
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
        return;
      } else {
        // NOTE (m-myUpload) to upload files
        this.myImageFile.showProgress = true;
        this.myImageFile.variant = "info";
        this.myImageFile.uploadPercentage = 0;
        this.myImageFile.isUploaded = false;
        this.myImageFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.profileLoading = true;
        this.$http
          .post(
            this.baseUrl +
              "/setad/admin/researcher/avatar?researcherId=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myImageFile.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.myImageFile.isUploaded = true;
              this.myImageFile.uploadPercentage = 100;
              this.myImageFile.striped = false;
              this.myImageFile.variant = "success";
              this.myImageFile.uploadButDisable = false;
              this.profile.avatar = d.data;
              this.profileLoading = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.profileLoading = false;
          });
      }
    },
    getCats() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/cats/list",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.categories = [];
          this.categories.push(
            ...res.data.map((x) => {
              return {
                code: x.id,
                label: x.name,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },
  computed: {
    computedItems() {
      if (this.items) {
        return this.items.sort((a, b) => {
          if (a.time < b.time) {
            return 1;
          }
          if (a.time > b.time) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else return [];
    },
    disabledBtn() {
      if (this.wrongDoi.length) {
        if (this.wrongDoi.includes(true)) {
          return true;
        } else return false;
      } else return false;
    },
  },
  mounted() {
    this.getCountries();
    this.getCats();
    this.onMounted();
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped lang="scss">
.color {
  background-color: #0c4961;
  color: white;
}
.img-box {
  border-radius: 10px;
  margin-bottom: 15px;
  position: relative;
  overflow: hidden;
  width: 170px;
  height: 170px;
  border: none;

  &:hover {
    background-color: black !important;
    .img {
      opacity: 0.7;
    }

    .img-icon {
      display: block;
    }
  }

  .img {
    opacity: 1;
    width: 100%;
    height: 100%;
  }
  .img-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: none;
  }
  .img-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #3a82b539;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
</style>
